import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
import { convertThreshold } from 'z3k-parser/model/z3k-config/sensors/utils';
export var WiredTemperatureSensor;
(function (WiredTemperatureSensor) {
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["NO_CONNECT"] = 1] = "NO_CONNECT";
        StatusFlags[StatusFlags["IS_TRIGGERED_LOW"] = 2] = "IS_TRIGGERED_LOW";
        StatusFlags[StatusFlags["IS_TRIGGERED_HIGH"] = 4] = "IS_TRIGGERED_HIGH";
        StatusFlags[StatusFlags["UNKNOWN"] = 8] = "UNKNOWN";
        StatusFlags[StatusFlags["NO_CONNECT_EVENT"] = 16] = "NO_CONNECT_EVENT";
        /* Extention board  flags */
        StatusFlags[StatusFlags["TEMP_SENT"] = 32] = "TEMP_SENT";
        StatusFlags[StatusFlags["EXTENTION_BOARD_SENSOR"] = 64] = "EXTENTION_BOARD_SENSOR";
        /*-----*/
        StatusFlags[StatusFlags["TEMPORARY_SENSOR"] = 128] = "TEMPORARY_SENSOR";
        StatusFlags[StatusFlags["IS_RESTORED"] = 256] = "IS_RESTORED";
    })(StatusFlags = WiredTemperatureSensor.StatusFlags || (WiredTemperatureSensor.StatusFlags = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["IS_OUTSIDE"] = 1] = "IS_OUTSIDE";
        Flags[Flags["MANUAL_COLOR"] = 2] = "MANUAL_COLOR";
        Flags[Flags["COLOR_BIT_1"] = 4] = "COLOR_BIT_1";
        Flags[Flags["COLOR_BIT_2"] = 8] = "COLOR_BIT_2";
        Flags[Flags["COLOR_BIT_3"] = 16] = "COLOR_BIT_3";
        Flags[Flags["COLOR_BIT_4"] = 32] = "COLOR_BIT_4";
        Flags[Flags["COLOR_BIT_5"] = 64] = "COLOR_BIT_5";
        Flags[Flags["HW_SLOT_BIT_0"] = 128] = "HW_SLOT_BIT_0";
        Flags[Flags["HW_SLOT_BIT_1"] = 256] = "HW_SLOT_BIT_1";
        Flags[Flags["HW_SLOT_BIT_2"] = 512] = "HW_SLOT_BIT_2";
        Flags[Flags["EVENT_TO_SERVER_FLAG_INVERTED"] = 1024] = "EVENT_TO_SERVER_FLAG_INVERTED";
        Flags[Flags["PRESSURE_SENSOR_TYPE_BIT_0"] = 2048] = "PRESSURE_SENSOR_TYPE_BIT_0";
        Flags[Flags["PRESSURE_SENSOR_TYPE_BIT_1"] = 4096] = "PRESSURE_SENSOR_TYPE_BIT_1";
        Flags[Flags["USE_DIAG_BUS"] = 8192] = "USE_DIAG_BUS";
        Flags[Flags["CONNECT_PLUS_WATER_SENSOR"] = 8192] = "CONNECT_PLUS_WATER_SENSOR";
        Flags[Flags["IS_OUTSIDE_RESERVE"] = 16384] = "IS_OUTSIDE_RESERVE";
    })(Flags = WiredTemperatureSensor.Flags || (WiredTemperatureSensor.Flags = {}));
    let PressureType;
    (function (PressureType) {
        PressureType[PressureType["BAR5"] = 0] = "BAR5";
        PressureType[PressureType["BAR12"] = 1] = "BAR12";
        PressureType[PressureType["BAR8"] = 2] = "BAR8";
    })(PressureType = WiredTemperatureSensor.PressureType || (WiredTemperatureSensor.PressureType = {}));
    function isOutside(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE);
    }
    WiredTemperatureSensor.isOutside = isOutside;
    function isOutsideReserve(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE_RESERVE);
    }
    WiredTemperatureSensor.isOutsideReserve = isOutsideReserve;
    function isEventToServer(sensor) {
        return !isFlagSet(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED);
    }
    WiredTemperatureSensor.isEventToServer = isEventToServer;
    function setEventToServer(sensor, eventToServer) {
        return setFlag(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED, !eventToServer);
    }
    WiredTemperatureSensor.setEventToServer = setEventToServer;
    function isConnectPlusWaterSensor(sensor) {
        return isFlagSet(sensor, Flags.CONNECT_PLUS_WATER_SENSOR);
    }
    WiredTemperatureSensor.isConnectPlusWaterSensor = isConnectPlusWaterSensor;
    function isManualColor(wts) {
        return isFlagSet(wts, Flags.MANUAL_COLOR);
    }
    WiredTemperatureSensor.isManualColor = isManualColor;
    function getColor(sensor) {
        if (!isManualColor(sensor)) {
            return 0;
        }
        return (sensor.setting_register >> 1) & 0x1f;
    }
    WiredTemperatureSensor.getColor = getColor;
    function setColor(sensor, color) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~(0x1f << 1)) | (color << 1),
        };
    }
    WiredTemperatureSensor.setColor = setColor;
    WiredTemperatureSensor.internet_temp = 'FF00FF00FF00FF';
    WiredTemperatureSensor.wts_internet_temp = {
        name: 'Погода из интернета',
        serial: WiredTemperatureSensor.internet_temp,
        upper_threshold: null,
        lower_threshold: null,
        hysteresis: 0,
        no_connection_timeout: 0,
        rol_connection_lost: [],
        rol_temperature_upper_threshold: [],
        rol_temperature_lower_threshold: [],
        io_extension_id: null,
        recovery_list: [],
        setting_register: 0,
        position: 0,
        calibration_shift: 0,
    };
    function isInternetTemp(sensor) {
        return sensor.serial == WiredTemperatureSensor.internet_temp;
    }
    WiredTemperatureSensor.isInternetTemp = isInternetTemp;
    function allInternetSensor(config) {
        return WiredTemperatureSensor.get.where(config, ({ serial }) => WiredTemperatureSensor.internet_temp === serial);
    }
    WiredTemperatureSensor.allInternetSensor = allInternetSensor;
    function isRealSensor(sensor) {
        if (sensor.serial) {
            return !isInternetTemp(sensor);
        }
        return true;
    }
    WiredTemperatureSensor.isRealSensor = isRealSensor;
    function setWeatherWired(sensor, need_weather) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~Flags.IS_OUTSIDE) |
                (need_weather ? Flags.IS_OUTSIDE : 0),
        };
    }
    WiredTemperatureSensor.setWeatherWired = setWeatherWired;
    function getSensors(config) {
        return WiredTemperatureSensor.get.where(config, isRealSensor);
    }
    WiredTemperatureSensor.getSensors = getSensors;
    function getPressureType(sensor) {
        return ((sensor.setting_register >> 11) & 0x3);
    }
    WiredTemperatureSensor.getPressureType = getPressureType;
    function setPressureType(sensor, value) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~(0x3 << 11)) | (value << 11),
        };
    }
    WiredTemperatureSensor.setPressureType = setPressureType;
    function getLimits(sensor, owa_m) {
        return {
            high: 
            //@ts-ignore
            sensor.upper_threshold === '' || sensor.upper_threshold == null
                ? null
                : parseFloat(sensor.upper_threshold + '') * owa_m,
            low: 
            //@ts-ignore
            sensor.lower_threshold === '' || sensor.lower_threshold == null
                ? null
                : parseFloat(sensor.lower_threshold + '') * owa_m,
        };
    }
    WiredTemperatureSensor.getLimits = getLimits;
    function convertThresholds(sensor) {
        return {
            ...sensor,
            upper_threshold: convertThreshold(sensor.upper_threshold),
            lower_threshold: convertThreshold(sensor.lower_threshold),
        };
    }
    WiredTemperatureSensor.convertThresholds = convertThresholds;
    WiredTemperatureSensor.get = createAccessors(arrayGetSet('wired_temperature_sensors'), {
        name: 'Цифровой датчик температуры',
        serial: '',
        upper_threshold: null,
        lower_threshold: null,
        hysteresis: 0,
        no_connection_timeout: 5,
        rol_connection_lost: [],
        rol_temperature_upper_threshold: [],
        rol_temperature_lower_threshold: [],
        recovery_list: [],
        setting_register: 0,
        io_extension_id: null,
        position: 0,
        calibration_shift: 0,
    });
})(WiredTemperatureSensor || (WiredTemperatureSensor = {}));
